import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import FooterDesktop from './FooterDesktop/FooterDesktopComponent';
import FooterMobile from './FooterMobile/FooterMobileComponent';
import { LEVEL } from './constants';
import './index.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var CanadaFooter = function CanadaFooter(_ref) {
  var predefinedPhone = _ref.predefinedPhone;
  var _useState = useState(predefinedPhone || false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsPhone = _useState2[1];
  useEffect(function () {
    var setAdaptiveFromWindowSize = function setAdaptiveFromWindowSize() {
      var windowInnerWidth = typeof window !== 'undefined' ? window.innerWidth : 1;
      setIsPhone(Boolean(windowInnerWidth && windowInnerWidth <= 1050));
    };
    setAdaptiveFromWindowSize();
    window.addEventListener('resize', setAdaptiveFromWindowSize, true);
    return function () {
      return window.removeEventListener('resize', setAdaptiveFromWindowSize, true);
    };
  }, []);
  if (!isMobile && typeof window === 'undefined') {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  var language = Cookie.get('user_language') === 'fr' || window.navigator.language === 'fr' ? {
    original: 'English',
    abbreviated: 'EN',
    href: "".concat(LEVEL)
  } : {
    original: 'Français',
    abbreviated: 'FR',
    href: "".concat(LEVEL, "/fr-ca")
  };
  return /*#__PURE__*/_jsx("div", {
    id: "carfax-global-footer-ca",
    children: isMobile ? /*#__PURE__*/_jsx(FooterMobile, {}) : /*#__PURE__*/_jsx(FooterDesktop, {
      language: language
    })
  });
};
export default CanadaFooter;